
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sarwa-life",
      function () {
        return require("private-next-pages/sarwa-life/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sarwa-life"])
      });
    }
  